(function () {
  const STORAGE_KEY = 'landingSmoothScrollTarget';
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const landingTargets = new Set([
    '#how-the-magic-happens',
    '#from-photo-to-storybook-character',
    '#stories-for-every-age-and-stage',
    '#customer-reviews',
    '#faq',
    '#what-adventure-awaits-today',
    '#bestselling-stories'
  ]);

  function normalizePath(pathname) {
    const normalized = pathname.replace(/\/$/, '');
    return normalized === '' ? '/' : normalized;
  }

  function isLandingPath(pathname) {
    return normalizePath(pathname) === '/';
  }

  function scrollToTarget(hash, updateUrl) {
    const target = document.querySelector(hash);
    if (!target) return false;

    target.scrollIntoView({
      behavior: reduceMotion ? 'auto' : 'smooth',
      block: 'start'
    });

    if (updateUrl) {
      history.pushState(null, '', hash);
    }

    return true;
  }

  function closeMobileMenuIfOpen(callback) {
    const mobileMenuInstance = window.mobileMenuInstance;
    if (mobileMenuInstance && mobileMenuInstance.isOpen) {
      mobileMenuInstance.close();
      if (callback) {
        setTimeout(callback, 320);
      }
      return true;
    }
    if (callback) {
      callback();
    }
    return false;
  }

  document.addEventListener('click', function (event) {
    const link = event.target.closest('a[href]');
    if (!link) return;

    try {
      const url = new URL(link.href, window.location.origin);

      if (url.origin !== window.location.origin) return;
      if (!isLandingPath(url.pathname)) return;
      if (!landingTargets.has(url.hash)) return;

      const currentlyOnLanding = isLandingPath(window.location.pathname);

      if (currentlyOnLanding) {
        const target = document.querySelector(url.hash);
        if (!target) return;

        event.preventDefault();

        closeMobileMenuIfOpen(function() {
          requestAnimationFrame(function() {
            requestAnimationFrame(function() {
              scrollToTarget(url.hash, true);
            });
          });
        });
      } else {
        event.preventDefault();
        sessionStorage.setItem(STORAGE_KEY, url.hash);
        closeMobileMenuIfOpen(function() {
          window.location.href = '/';
        });
      }
    } catch (e) {
      return;
    }
  });

  window.addEventListener('DOMContentLoaded', function () {
    if (!isLandingPath(window.location.pathname)) return;
    const storedHash = sessionStorage.getItem(STORAGE_KEY);
    if (storedHash && landingTargets.has(storedHash)) {
      sessionStorage.removeItem(STORAGE_KEY);
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          scrollToTarget(storedHash, false);
          history.replaceState(null, '', storedHash);
        });
      });
      return;
    }
    if (landingTargets.has(window.location.hash)) {
      requestAnimationFrame(function () {
        scrollToTarget(window.location.hash, false);
      });
    }
  });

  window.addEventListener('popstate', function () {
    if (landingTargets.has(window.location.hash) && isLandingPath(window.location.pathname)) {
      requestAnimationFrame(function () {
        scrollToTarget(window.location.hash, false);
      });
    }
  });
})();
